import {ConsoleComponent} from '@applications/console.component';
import {BrowserComponent} from '@applications/browser.component';
import {FileExplorerComponent} from '@applications/file-explorer/file-explorer.component';
import {Application, APPLICATION_CATEGORY} from '@interfaces/interfaces';
import {WelcomeComponent} from '@applications/welcome/welcome.component';
import {fs, FS_PATH_MAPPING} from '@constants/filesystem';
import {TextEditorComponent} from '@applications/text-editor/text-editor.component';
import {KnightsAndMonstersComponent} from '@applications/knights-and-monsters/knights-and-monsters.component';
import {RandomNameGeneratorComponent} from '@applications/random-name-generator/random-name-generator';

const explorer = new Application({
  title: 'File explorer',
  component: 'FileExplorerComponent',
  alt: 'View files and applications',
  icon: 'folderIcon',
  iconContrast: 'folderIcon',
  size: {width: '1200px', height: '1000px'},
  fs: {
    category: APPLICATION_CATEGORY.UTILITY,
    paths: [
      fs.getPath(FS_PATH_MAPPING.APPLICATION),
      fs.getPath(FS_PATH_MAPPING.UTILITIES),
      fs.getPath(FS_PATH_MAPPING.DESKTOP)
    ]
  }
});

const textEditor = new Application({
  title: 'Text editor',
  component: 'TextEditorComponent',
  alt: 'Text editor app',
  icon: 'textEditorIcon',
  iconContrast: 'textEditorIcon',
  fullScreen: true,
  size: {width: '1200px', height: '1000px'},
  fs: {
    category: APPLICATION_CATEGORY.UTILITY,
    paths: [
      fs.getPath(FS_PATH_MAPPING.APPLICATION),
      fs.getPath(FS_PATH_MAPPING.UTILITIES)
    ]
  }
});

const console = new Application({
  title: 'Console',
  component: 'ConsoleComponent',
  alt: 'A simple console wich displays a part of redux state changes',
  icon: 'console',
  iconContrast: 'console',
  startPosition: {x: '200px', y: '200px'},
  size: {width: '800px', height: '500px'},
  fs: {
    category: APPLICATION_CATEGORY.UTILITY,
    paths: [
      fs.getPath(FS_PATH_MAPPING.UTILITIES),
      fs.getPath(FS_PATH_MAPPING.APPLICATION)
    ]
  }
});

const welcome = new Application({
  title: 'Welcome',
  component: 'WelcomeComponent',
  alt: '...',
  icon: 'home',
  iconContrast: 'home',
  fullScreen: false,
  size: {width: '1000px', height: '800px'},
  fs: {
    category: APPLICATION_CATEGORY.INFO,
    paths: [
      fs.getPath(FS_PATH_MAPPING.APPLICATION),
      fs.getPath(FS_PATH_MAPPING.INFO),
      fs.getPath(FS_PATH_MAPPING.DESKTOP)
    ]
  }
});

const browser_spaceInvaders = new Application({
  title: 'Bandcamp',
  alt: 'Checkout my Bandcamp',
  component: 'BrowserComponent',
  icon: 'unity',
  iconContrast: 'unity',
  fullScreen: true,
  size: {width: '1200px', height: '1000px'},
  data: {url: 'https://xfallen.bandcamp.com'},
  fs: {
    category: APPLICATION_CATEGORY.UTILITY,
    paths: [
      fs.getPath(FS_PATH_MAPPING.APPLICATION),
      fs.getPath(FS_PATH_MAPPING.PROJECTS)
    ]
  }
});

const browser_helloUnity = new Application({
  title: 'Hello Unity',
  component: 'BrowserComponent',
  alt: 'Take a look to an example of Unity3D webgl export and templating',
  icon: 'unity',
  iconContrast: 'unity',
  size: {width: '1200px', height: '1000px'},
  data: {url: 'https://www.youtube.com/channel/UCmJqyNQWj_imjSHUnmLRVrg'},
  fs: {
    category: APPLICATION_CATEGORY.GAME,
    paths: [
      fs.getPath(FS_PATH_MAPPING.APPLICATION),
      fs.getPath(FS_PATH_MAPPING.GAMES)
    ]
  }
});

const browser_polyGone = new Application({
  title: 'Poly Gone',
  component: 'BrowserComponent',
  alt: 'made by NicolaLC',
  icon: 'polygone_logo',
  iconContrast: 'polygone_logo',
  fullScreen: true,
  size: {width: '720px', height: '1280px'},
  data: {url: 'assets/static/webgl/polygone/index.html'},
  fs: {
    category: APPLICATION_CATEGORY.GAME,
    paths: [
      fs.getPath(FS_PATH_MAPPING.APPLICATION),
      fs.getPath(FS_PATH_MAPPING.GAMES),
      fs.getPath(FS_PATH_MAPPING.DESKTOP)
    ]
  }
});

const browser_relativeGravity = new Application({
  title: 'YouTube',
  component: 'BrowserComponent',
  alt: 'My YouTube Channel',
  icon: 'unity',
  iconContrast: 'unity',
  fullScreen: true,
  size: {width: '720px', height: '1280px'},
  data: {url: 'http://youtube.com/xFallenDemon99x'},
  fs: {
    category: APPLICATION_CATEGORY.GAME,
    paths: [
      fs.getPath(FS_PATH_MAPPING.APPLICATION),
      fs.getPath(FS_PATH_MAPPING.GAMES),
      fs.getPath(FS_PATH_MAPPING.DESKTOP)
    ]
  }
});

const browser_autoBattler = new Application({
  title: 'Reddit',
  component: 'BrowserComponent',
  alt: 'xFD99x Subreddit',
  icon: 'reddit',
  iconContrast: ' ',
  fullScreen: true,
  size: {width: '720px', height: '1280px'},
  data: {url: 'http://reddit.com/r/xFallenDemon99x'},
  fs: {
    category: APPLICATION_CATEGORY.GAME,
    paths: [
      fs.getPath(FS_PATH_MAPPING.APPLICATION),
      fs.getPath(FS_PATH_MAPPING.GAMES),
      fs.getPath(FS_PATH_MAPPING.DESKTOP)
    ]
  }
});

const knightsAndMonsters = new Application({
  title: 'Knights VS Monsters',
  component: 'KnightsAndMonstersComponent',
  alt: 'Play Knights VS Monsters Now!',
  icon: 'unity',
  iconContrast: 'unity',
  size: {width: '1200px', height: '1000px'},
  fullScreen: true,
  fs: {
    category: APPLICATION_CATEGORY.GAME,
    paths: [
      fs.getPath(FS_PATH_MAPPING.APPLICATION),
      fs.getPath(FS_PATH_MAPPING.GAMES)
    ]
  }
});

const randomNameGenerator = new Application({
  title: 'Reddit',
  component: 'BrowserComponent',
  alt: 'xFD99x Subreddit',
  icon: 'reddit',
  iconContrast: ' ',
  fullScreen: true,
  size: {width: '720px', height: '1280px'},
  data: {url: 'http://reddit.com/r/xFallenDemon99x'},
  fs: {
    category: APPLICATION_CATEGORY.UTILITY,
    paths: [
      fs.getPath(FS_PATH_MAPPING.APPLICATION),
      fs.getPath(FS_PATH_MAPPING.UTILITIES)
    ]
  }
});

export const APPLICATIONS: { [key: string]: Application } = {
  console,
  welcome,
  browser_spaceInvaders,
  explorer,
  textEditor,
  
};


export const applicationMapping = {
  'WelcomeComponent': WelcomeComponent,
  'ConsoleComponent': ConsoleComponent,
  'BrowserComponent': BrowserComponent,
  'FileExplorerComponent': FileExplorerComponent,
  'TextEditorComponent': TextEditorComponent,
  'RandomNameGeneratorComponent': RandomNameGeneratorComponent,
};
